<template>
  <div :class="`trust-wrap trust-wrap--${getWrapModifier()} trust-wrap--comment`">
    <ul class="trust-list">
      <li
        :class="`trust-list__item trust-list__item--${key} ${getActive(trust)}`"
        v-for="(trust, key) in trusts"
        :key="key"
        @click="setTrust(trust.value)"
      >
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Trust',
    props: {
      trust: {
        type: Number
      },
    },
    data() {
      return {
        trusts: {
          negative: {
            value: -1
          },
          netural: {
            value: 0
          },
          positive: {
            value: 1
          }
        }
      };
    },
    methods: {
      setTrust(trust) {
        this.$emit('setTrust', trust);
      },
      getWrapModifier() {
        const trustKeys = Object.entries(this.trusts);
        const trust = trustKeys.find(item => item[1].value === this.trust);

        return trust[0];
      },
      getActive(trust) {
        return trust.value === this.trust ? 'trust-list__item--active' : '';
      },
    }
  };
</script>

<style>

</style>
